module.exports = __webpack_public_path__ + "images/vervoermaterieel_smallfd84f7930d51e9941d72f557d93b9466.png";